export const COMPANY_INN = "307308543"